import { MapContainer, TileLayer, useMapEvent, Marker } from 'react-leaflet';
import { Icon } from 'leaflet';
import { osm } from '../../mapTiler/osmProvider.js';
import postionIcon from '../../static/images/map_marker_icon.png'
import 'leaflet/dist/leaflet.css';
import { useEffect, useState, useRef } from 'react';

// Questo è il componente per settare le coordinate di ogni attività in fase di inserimento/modifica da parte degli admin
const ActivityLocationMap = ({ onMapClick, coordinates, isManualSet, setIsManualSet }) => {
    const mapRef = useRef(null);
    const [zoomLevel, setZoomLevel] = useState(10)
    const [markerPosition, setMarkerPosition] = useState(null);

    useEffect(() => {
        if (isManualSet && isManualSet.isManual) {
            let newLocation = {
                lat: isManualSet.coo[0],
                lng: isManualSet.coo[1]
            }
            /* setMapCenter(newLocation); */
            if (mapRef.current) {
                mapRef.current.flyTo(newLocation, zoomLevel, {
                    duration: 2
                })
            }
            setTimeout(() => {
                setMarkerPosition(isManualSet.coo)
                onMapClick({
                    lat: isManualSet.coo[0],
                    lng: isManualSet.coo[1]
                })
            }, [2000])
            setIsManualSet({
                isManualSet: false,
                coo: null
            })
        }
    }, [isManualSet])

    const markerIcon = new Icon({
        iconUrl: postionIcon,
        iconSize: [32, 64]
    })

    const MapEvent = () => {
        const map = useMapEvent('click', (event) => {
            onMapClick(event.latlng);
            setMarkerPosition(event.latlng)
        })
    }

    return (
        <div className='w-full lg:w-[800px] my-8 border-2 rounded'>
            <MapContainer className='h-[380px] w-full !cursor-pointer' center={coordinates ? coordinates : [46.8800262325221, 8.216171039114357]} zoom={zoomLevel} ref={mapRef}>
                <TileLayer url={osm.maptiler.url} attribution={osm.maptiler.attribution} />
                <MapEvent />
                {
                    markerPosition &&
                    <Marker position={markerPosition} icon={markerIcon}>
                    </Marker>
                }
            </MapContainer>
        </div>
    )
}

export default ActivityLocationMap;